<div class="container">
    <div class="top_container">
        <div class="title">{{ "confirmation_block.delivery_confirmation.title" | translate }}</div>
        <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="closePopin()">
    </div>
    <div class="body">
        <div class="picto_container">
            <img class="picto" src="assets/images/check-ok.svg">
        </div>
        <div class="label_container">
            <div class="label" *ngIf="message1">{{message1 | translate}}</div>
            <div class="label" *ngIf="message2">{{message2 | translate}}</div>
        </div>
    </div>
</div>